// extracted by mini-css-extract-plugin
export default {"addNewEmailBtn":"AlternateEmails_addNewEmailBtn__tZn9k","emailsContainer":"AlternateEmails_emailsContainer__53bkE","text":"AlternateEmails_text__c0btb"};